<template>
  <div class="content-container">
    <v-row justify="center">
      <v-col cols="8">
        <v-card outlined>
          <v-card-title>
            <v-icon>mdi-file-question-outline</v-icon>  Add FAQ Content
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row>
              <v-col>
                <v-form
                  ref="myForm"
                  lazy-validation
                >
                  <div class="mb-7">
                    <v-sheet
                      class="pa-6"
                      outlined
                    >
                      <div class="overline mb-4">FAQ Information</div>

                      <v-text-field
                        v-model="faq.question"
                        :rules="[v => !!v || 'Question is required',]"
                        label="FAQ Question *"
                        required
                      ></v-text-field>
                      
                      <h4 class="font-weight-regular mt-4 mb-3">FAQ Answer</h4>
                      <div class="mb-6">
                        <vue-editor v-model="faq.answer" />
                      </div> 
                      <v-switch
                        class=""
                        v-model="faq.active"
                        color="success"
                        label="Active"
                        value="1"
                        inset
                        hide-details
                      ></v-switch> 
                    </v-sheet>
                  </div>
                  <div class="mb-7">
                    <v-sheet
                      class="pa-6"
                      outlined
                    >
                      <div class="overline">Assign to FAQ Categories</div>

                      <div class="mt-5">
                        <v-treeview
                          v-model="selectedFaqCats"
                          selectable
                          item-disabled="locked"
                          :items="faqHierarchy"
                        ></v-treeview>
                      </div>
                    </v-sheet>
                  </div>

                  <div>
                    <v-sheet
                      class="pa-6"
                      outlined
                    >  
                      <v-row>
                        <v-col cols="12" lg="7">
                          <div class="overline mb-5">Assign Tags</div>

                          <div class="caption">
                            
                            <v-row class="mb-5">
                              <v-col class="col-auto">
                                <v-icon color="warning">mdi-alert-circle</v-icon>
                              </v-col>
                              <v-col>Use drop-down to select tags. If your desired tag is not on the list, you can add by clicking the "Managage FAQ Tag Database" button below.</v-col>
                            </v-row>

                          </div>
                          <div>
                            <v-combobox
                              label="Select Tags"
                              v-model="tagSelect"
                              :items="tagSelectItems"
                              :item-value="tagSelectItems.tag_ID"
                              :item-text="tagSelectItems.tag"
                              clearable
                              multiple
                              small-chips
                            ></v-combobox>
                          </div>
                          <div class="float-right">
                            <v-btn
                              text
                              color="primary"
                              x-small
                              @click="manangeTags"
                            >
                              Manage FAQ Tag Database
                            </v-btn>
                          </div>
                        </v-col>
                      </v-row>
                    </v-sheet>
                  </div>
                  
                </v-form>    
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-btn
              text
              color="info"
              large
              @click="reset"
            >
              Clear Form
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              :loading="loading"
              :disabled="loading"
              color="secondary"
              large
              elevation="0"
              class="px-10"
              @click="validate"
            >
              Add FAQ Content
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>   
    <edit-faq-tag-modal></edit-faq-tag-modal>
  </div>
  
</template>
<script>
import { VueEditor } from "vue2-editor"
import EditFaqTagModal from "../components/EditFaqTagModal.vue"

export default {
  name: 'AddFaq',
  data: () => ({
    faq: {
      question: null,
      answer: null,
      active: '1'
    },
    faqHierarchy: null,
    selectedFaqCats: [],
    tags: [],
    tagData: [],

    tagSelect: null,
    tagSelectItems: [],

    newTag: '',
    newFaqTag: null,
    search: '',
    selectedTags: [],
    singleSelect: false,
    headers: [
        {
          text: 'FAQ Tag',
          align: 'start',
          value: 'tag',
        },
        { 
          text: 'Edit', 
          value: 'edit', 
          sortable: false,
          align: 'end'
        },
        { 
          text: 'Delete', 
          value: 'actions', 
          sortable: false,
          align: 'end'
        },
      ],
      loading: false,
    
    
  }),
  beforeMount() {
    this.$root.$emit("_loggedIn","Add FAQ Content")
    this.getCategorySchema()
    this.getFaqTags()
  },
  mounted() {
    this.$root.$on('resetFaqTags',() => {
      this.getFaqTags()
    })
  },
  methods:{
    async addTag(){

      let newTag = this.newFaqTag
      if (newTag.trim().length === 0) {
        return
      }

      const userObj = JSON.parse(localStorage.getItem('rccpa'))
          
      let postData = {
        tag: this.newFaqTag
      }

      var endpoint = '/portal-faq-tags'

      const url = process.env.VUE_APP_API_BASE_URL + endpoint
      const request = new Request(url, {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + userObj.jwt,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(postData),
        mode: 'cors',
      });

      fetch(request)
      .then(response => {
        return response.json();
      })
      .then((jsonResponse) => {

        if(jsonResponse.affectedRows){

          this.newFaqTag = ''
          
          const newID = jsonResponse.insertId 

       //   setTimeout(()=>{
            this.$root.$emit("notify","success",`${this.newFaqTag} has been added`)
            this.getFaqTags()
       //   },500)

          setTimeout(()=>{
            
            let selectedTags = this.tagSelect
            let tempSelectedTags = []
            for (let i = 0; i < selectedTags.length; i++) {
              tempSelectedTags.push(selectedTags[i])
            }

            let tempObj = {
              text: this.newFaqTag,
              value: newID
            }

            tempSelectedTags.push(tempObj)

            this.tagSelect = tempSelectedTags


          },250)

        }else{

          setTimeout(()=>{
            
            this.$root.$emit("notify","error","There was an error processing this request")
            
            
          },500)

        }
      })

        
    },
    getFaqTags(){
      
      this.tagSelectItems = []
      const userObj = JSON.parse(localStorage.getItem('rccpa'))

      var endpoint = '/portal-faq-tags'
      const url = process.env.VUE_APP_API_BASE_URL + endpoint
      
      const request = new Request(url, {
        method: 'GET',
        headers: {
          'Authorization': 'Bearer ' + userObj.jwt,
          'Content-Type': 'application/json'
        },
        mode: 'cors',
      })
        
      fetch(request)
      .then(response => {
        return response.json();
      })
      .then((jsonResponse) => {
        let arr = []
        let tempArr = jsonResponse
        for (let i = 0; i < tempArr.length; i++) {
          
          let tempObj = {
            text: tempArr[i].tag,
            value: tempArr[i].tag_ID
          }

          arr.push(tempObj)
        }
        this.tagSelectItems = arr
        
      })
    },
    manangeTags(){
      this.$root.$emit("openEditFaqTagModal")
    },
    getCategorySchema() {
      this.faqHierarchy = []
      const userObj = JSON.parse(localStorage.getItem('rccpa'))
      const target = 'faq'
      var endpoint = `/portal-category-schemas/${target}`
      const url = process.env.VUE_APP_API_BASE_URL + endpoint
    
      const request =  new Request(url, {
        method: 'GET',
        headers: {
          'Authorization': 'Bearer ' + userObj.jwt,
          'Content-Type': 'application/json'
        },
        mode: 'cors',
      })
    
      fetch(request)
      .then(response => {
        return response.json();
      })
      .then((jsonResponse) => {
        
        if(jsonResponse[0].category_schema_json){
            this.formatTree(JSON.parse(jsonResponse[0].category_schema_json))
        }
        // const success = (JSON.parse(jsonResponse[0].category_schema_json)) ? true : false
        
        // const jsonData = ( success ) ? JSON.parse(jsonResponse[0].category_schema_json) : null

        // const respObj = {
        //   success: success,
        //   data: jsonData
        // }
      
       

      })  
    },
    formatTree(json){
      
      let tempTreeObj = {}
      let tempTreeArr = []
      let tempSubsArr  = []
      let loopSubCatArr = []
      let loopSubCatObj = {}

      for (let i = 0; i < json.length; i++) {

        loopSubCatArr = []
        tempSubsArr  = []

        loopSubCatArr = json[i].subcats
        if(loopSubCatArr.length > 0){
          
          for (let iSubs = 0; iSubs < loopSubCatArr.length; iSubs++) {
            loopSubCatObj = {
              id: loopSubCatArr[iSubs].faq_cat_ID,
              name: loopSubCatArr[iSubs].faq_category,
              locked: false,
              children: []
            }

            tempSubsArr.push(loopSubCatObj)

          }

          

        }

        tempTreeObj = {
          id: json[i].faq_cat_ID,
          name: json[i].faq_category,
          locked: false,
          children: tempSubsArr
        }

        tempTreeArr.push(tempTreeObj)
      }

      this.faqHierarchy = tempTreeArr
      /*

       {
          id: 1,
          name: 'Applications :',
          locked: true,
          children: [
            { id: 2, name: 'Calendar : app' },
            { id: 3, name: 'Chrome : app' },
            { id: 4, name: 'Webstorm : app' },
          ],
        },

      */

      /*
      {
        "faq_cat_ID": 16,
        "faq_category": "Instrument",
        "subcats": [
          {
            "faq_cat_ID": 17,
            "faq_category": "Specifications",
            "subcats": []
          },
          {
            "faq_cat_ID": 18,
            "faq_category": "Troubleshooting",
            "subcats": []
          }
        ]
      }
      */

    },
    async validate(){
     
      if(this.$refs.myForm.validate()){
       
        this.loading = true
        
        const userObj = JSON.parse(localStorage.getItem('rccpa'))

        const faqQuestion = this.faq.question
        const faqAnswer = this.faq.answer
        const active = (this.faq.active) ? "1" : "0"
        
        let postData = {
          faq_title: faqQuestion,
          faq_content: faqAnswer,
          active: active,
        }

        var endpoint = '/portal-faqs'

        const url = process.env.VUE_APP_API_BASE_URL + endpoint
        const request = new Request(url, {
          method: 'POST',
          headers: {
            'Authorization': 'Bearer ' + userObj.jwt,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(postData),
          mode: 'cors',
        });


        const insertResult = await fetch(request)
        .then(response => {
          return response.json();
        })
        .then((jsonResponse) => {
          return jsonResponse
        })

        if(insertResult.affectedRows === 1) {
          
          setTimeout(()=>{
            this.$root.$emit("notify","success","FAQ has been added")
            this.loading = false

            this.reset()
            // this.faq = {
            //   question: null,
            //   answer: null,
            //   active: '1'
            // }

            // this.selectedFaqCats = []

            // this.$refs.myForm.reset()

          }, 2000 )
          
          
          const insertId = insertResult.insertId

          // INSERT CATEGORIES
          if( this.selectedFaqCats && this.selectedFaqCats.length > 0){
            
            const addFaqCats = await this.addFaqCats(insertId)
            
            if(addFaqCats.affectedRows === 0) {
              // error alert
              setTimeout(()=>{
                this.$root.$emit("notify","error","There was an error updating FAQ categories")
              }, 1200 )
            }

          }

          // INSERT TAGS
          if( this.tagSelect && this.tagSelect.length > 0 ){

            const addFaqTags = await this.addFaqTags(insertId)
            
            if(addFaqTags.affectedRows === 0) {
              // error alert
              setTimeout(()=>{
                this.$root.$emit("notify","error","There was an error updating FAQ tags")
              }, 1200 )
            }
          }

        }else{
          setTimeout(()=>{
            this.$root.$emit("notify","error","There was an error creating this record")
            this.loading = false
          },500)
        }

      }
       
    },    
    async addFaqCats(insertId){
      
      const faqCats = this.selectedFaqCats
    
      const userObj = JSON.parse(localStorage.getItem('rccpa'))
      
      let postData = {
        faq_cat_IDs: faqCats,
        faq_ID: insertId,
      }

      var endpoint = '/portal-faq-category-assignments'

      const url = process.env.VUE_APP_API_BASE_URL + endpoint
      const request = new Request(url, {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + userObj.jwt,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(postData),
        mode: 'cors',
      });

      const catsResponse = fetch(request)
      .then(response => {
        return response.json();
      })
      .then((jsonResponse) => {
        return jsonResponse
      })

      return catsResponse
     
    },
    async addFaqTags(insertId){
      
      let tagIdArr = []
      
      for (let i = 0; i < this.tagSelect.length; i++) {
        tagIdArr.push(this.tagSelect[i].value)
      }

      const userObj = JSON.parse(localStorage.getItem('rccpa'))
      
      let postData = {
        tag_IDs: tagIdArr,
        faq_ID: insertId,
      }

      var endpoint = '/portal-faq-tag-assignments'

      const url = process.env.VUE_APP_API_BASE_URL + endpoint
      const request = new Request(url, {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + userObj.jwt,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(postData),
        mode: 'cors',
      });

      const tagsResponse = fetch(request)
      .then(response => {
        return response.json();
      })
      .then((jsonResponse) => {
        return jsonResponse
      })

      return tagsResponse
     
    },
    reset () {
      this.selectedFaqCats = []
      this.$refs.myForm.reset()
      this.faq = {
        question: null,
        answer: null,
        active: '1'
      }
    },
    
  },
  components:{
    VueEditor,
    EditFaqTagModal
  }
}
</script>